(() => {
  if (window.KarmaCart) return;

  const EVENT = 'cart:updated';

  const dispatch = (cart) => {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { cart } }));
    return cart;
  };

  const refresh = async () => {
    const base = ((window.routes && window.routes.root_url) || '/').replace(/\/$/, '');
    const res = await fetch(`${base}/cart.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`cart.js responded ${res.status}`);
    return dispatch(await res.json());
  };

  // Aurora exposes no cart event, but it re-renders the header
  // <cart-count id="CartCount"> on every cart change (add, qty, remove, from
  // anywhere). Watch that one node and re-read the cart when it changes.
  const node = document.getElementById('CartCount');
  if (node) {
    new MutationObserver(() => refresh().catch(() => {})).observe(node, { childList: true });
  }

  window.KarmaCart = { EVENT, dispatch, refresh };
})();
